export default __webpack_public_path__ + "static/icons-cfb28b5cd63c67cf2f155c4bc47790e1.svg";